import axios from "axios"

export const validate = (code) => axios.get(`/api/v2/invite_links/${code}`)

export const inviteLink = () => axios.get("/api/v2/account/referral_invite_link")
